import { useUserData } from '@contexts/UserDataContext'
import { logVerseRead, getTodayKey } from 'helpers/readingChallengeHelpers'
import { useCallback } from 'react'

export const useReadingSession = () => {
  const { userData, updateUserData, updateMultipleUserData } = useUserData()

  const challenge = userData.readingChallenge

  const recordVerseRead = useCallback(() => {
    const todayKey = getTodayKey()
    const currentStats = userData.stats || {}
    const todayStats = currentStats[todayKey] || { score: 0 }

    const newStats = {
      ...currentStats,
      [todayKey]: {
        ...todayStats,
        score: todayStats.score + 1,
        ayet_okuma: (todayStats.ayet_okuma || 0) + 0.5,
      },
    }

    if (challenge) {
      const updatedChallenge = logVerseRead(challenge)
      updateMultipleUserData({
        readingChallenge: updatedChallenge,
        stats: newStats,
      })
    } else {
      updateUserData('stats', newStats)
    }
  }, [challenge, userData.stats, updateMultipleUserData, updateUserData])

  // Computed values
  const todayLog = challenge?.dailyLog[getTodayKey()]
  const versesReadToday = todayLog?.versesRead || 0
  const goalCompletedToday = challenge ? versesReadToday >= challenge.dailyGoal : false

  const totalVersesRead = challenge?.totalVersesRead || 0

  return {
    versesReadToday,
    totalVersesRead,
    goalCompletedToday,
    recordVerseRead,
  }
}
